import { DimensionSystem } from '../../../shared/enums/dimension-system.enum';

export class DimensionUnitConfiguration {
  constructor(public dimensionUnit: DimensionSystem) {
  }
}
